import React, {useEffect, useState} from "react";
import {BasicProps} from "../App";
import SamaggiPaper from "../Components/SamaggiPaper";
import {Grid} from "@mui/material";
import {Colours, SamaggiTypography} from "../Components/SamaggiTypography";
import {SamaggiButton} from "../Components/SamaggiButton";
import axios from "axios";
import {handleError} from "../support";

export const Store: React.FC<BasicProps> = (props) => {

    interface ItemData {
        ItemName: string;
        ItemDescription: string;
        Price: number;
        Currency: string;
        ImageLink: string;
        Amount: number;
        ID: string;
        Section: string;
        Store: string;
    }

    useEffect(() => {
        props.setShowCover(true);

        const url = new URL(window.location.href);
        const storeID = url.pathname.split("/")[1]

        if (url.pathname.split("/").length === 2 && storeID !== "") {
            window.location.href = `/${storeID}/`
            return
        }

        axios.post("https://rwcahzmnb8.execute-api.eu-west-2.amazonaws.com/Prod/get-store", {
            "storeID": (storeID !== undefined && storeID !== "store") ? storeID : "", "token": localStorage.getItem("token")
        }).then((res) => {
            if (res.data.data.redirect === true) {
                console.log(res.data.data.redirect)
                window.location.href = `/${res.data.data.redirectStore}/`
                return
            }
            setStoreName(res.data.data.storeName);
            setItems(res.data.data.items);

            const sectionsTemp: Array<string> = [];

            res.data.data.items.forEach((item: ItemData) => {
                if (!sectionsTemp.includes(item.Section)) {
                    sectionsTemp.push(item.Section)
                }
            })

            setSections(sectionsTemp);

            document.title = res.data.data.storeName
            props.setShowCover(false);
        }).catch((error) => {
            handleError(error, true);
        })
    }, []);

    function checkout() {
        props.setShowCover(true);

        axios.post("https://rwcahzmnb8.execute-api.eu-west-2.amazonaws.com/Prod/checkout", {
            "token": localStorage.getItem("token"), "items": items
        }).then((res) => {
            window.location.href = res.data.data.URL;
        }).catch((error) => {
            handleError(error, true);
            props.setShowCover(false);
        })
    }

    const [sections, setSections] = useState<Array<string>>([]);
    const [items, setItems] = React.useState<Array<ItemData>>([{ItemName: "Test", Section: "Starters", ItemDescription: "Test Item", Price: 12, Currency: "GBP", ImageLink: "X", Amount: 0, ID: "ASAS", Store: "Test Store"}]);
    const [storeName, setStoreName] = React.useState("Samaggi Games Food Store");

    return (
        <div style={{paddingTop: "30px", paddingBottom: "30px", marginLeft: "auto", marginRight: "auto"}}>
            <Grid container direction={"column"} spacing={3}>
                <Grid item>
                    <SamaggiTypography bold center xlarge colour={Colours.samaggiGreen}>{storeName}</SamaggiTypography>
                </Grid>
                {sections.map((section: string) => <Grid container direction={"column"} spacing={4}>
                    <Grid item container direction={"column"} spacing={1}>
                        <Grid item>
                            <SamaggiTypography bold center xlarge sx={{marginTop: "40px"}}>{section}</SamaggiTypography>
                        </Grid>
                        <Grid item container direction={"row"} columnSpacing={2} rowSpacing={2} alignItems="stretch">
                            {items.filter((item) => item.Section === section).map((item) => <Grid key={`${item.ID}-GR1`} item xs={12} md={4} lg={3} sx={{ display: 'flex', flexDirection: 'column', minHeight: "100%" }}>
                                <SamaggiPaper maxWidth noMargin sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                    <Grid container direction={"column"} spacing={3} sx={{display: "block", marginBottom: "25px"}}>
                                        <Grid item xs={12}>
                                            <img src={item.ImageLink} style={{objectFit: "cover", maxWidth: "100%", aspectRatio: 1, width: "100%", display: "block"}} alt={item.ItemDescription}/>
                                        </Grid>
                                        <Grid item container direction={"column"} spacing={1}>
                                            <Grid item xs={12}>
                                                <SamaggiTypography bold>{item.ItemName}</SamaggiTypography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <SamaggiTypography small>{item.ItemDescription}</SamaggiTypography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    {/*<div style={{height: "20px", width: "100%"}}></div>*/}
                                    <Grid container direction={"column"} sx={{marginTop: "auto"}}>
                                        <Grid item>
                                            <SamaggiTypography center bold large>{item.Currency}{item.Price}</SamaggiTypography>
                                        </Grid>
                                        <Grid container item direction={"row"}>
                                            <Grid item xs={4}>
                                                <SamaggiButton fullWidth onClick={() => {if (item.Amount < 1) {return} item.Amount--; setItems([...items])}}> - </SamaggiButton>
                                            </Grid>
                                            <Grid item xs={4} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <SamaggiTypography center>{item.Amount} ({item.Currency}{item.Amount * item.Price})</SamaggiTypography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <SamaggiButton fullWidth onClick={() => {item.Amount++; setItems([...items])}}> + </SamaggiButton>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </SamaggiPaper>
                            </Grid>)}
                        </Grid>
                    </Grid>
                </Grid>)}
                <Grid item style={{paddingLeft: 0}}>
                    <SamaggiButton noPad disabled={items.filter((item) => item.Amount >= 1).length == 0} sx={{height: "90px"}} fullWidth onClick={() => checkout()}>Check Out</SamaggiButton>
                </Grid>
            </Grid>
        </div>
    )
}
